import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import './first-visit-overlay.scss';
import { triggerGTMPush } from 'redux/actions';

const FirstVisitOverlay = (props) => {
  
  const eventData = {
    'navMethod': 'Begin',
    'event': 'firstVisitOverlay',
    'virtualPath': props.location.pathname,
    'pageNo': 'undefined',
    'pageName': 'undefined'
  }
  
  props.triggerGTMPush(eventData)

  return (
    <div className="first-visit-overlay">
        <div className="first-visit-overlay__body">
            <h1 className="first-visit-overlay__heading">Welcome to the Beneficiary Claims learning tool</h1>
            
            <div className="first-visit-overlay__content">
                <p className="first-visit-overlay__text">There is audio to help you through this learning tool, step-by-step. Would you like to continue with sound? You can turn it off at any point by clicking the sound button in the top right corner.</p>
            </div>
            
            <div className="first-visit-overlay__buttons">
                <button 
                    onClick={props.handleContinueNoAudio}
                    className="first-visit-overlay__continue">No, turn off sound
                </button>

                <button 
                    onClick={props.handleContinue}
                    className="first-visit-overlay__begin">Yes, continue with sound
                </button> 
            </div>
        </div>
    </div>
  )
}

FirstVisitOverlay.propTypes = {
    handleContinue: PropTypes.func.isRequired,
    handleContinueNoAudio: PropTypes.func.isRequired,
    triggerGTMPush: PropTypes.func
}

const mapStateToProps = state => {
  return {
    overlayIsActive: state.overlayIsActive
  }
}

const mapDispatchToProps = dispatch => {
  return {
    triggerGTMPush: (eventData) => dispatch(triggerGTMPush(eventData))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FirstVisitOverlay))
